import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=7940cb98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7940cb98"]])

export default __exports__